export default function (callback, delay) {
    // Force our date objects all to ints, to avoid confusing Puppeteer
    // in our unit test.
    var timerId = null,
        start,
        remaining = Number(delay);

    this.delay = delay;

    this.called = false;
    this.callback_once = () => {
        if (!this.called) {
            this.called = true;
            callback();
        }
    };

    this.remaining = () => {
        return Math.max(remaining + start - Number(new Date()), 0);
    };

    this.cancel = () => {
        clearTimeout(timerId);
        this.cancelled = true;
    };

    this.pause = () => {
        clearTimeout(timerId);
        remaining -= Number(new Date()) - start;
        this.paused = true;
    };

    this.resume = () => {
        start = Number(new Date());
        clearTimeout(timerId);
        timerId = setTimeout(this.callback_once, remaining);
        this.paused = false;
    };

    this.resume();
}
